import React from 'react';
import AppPage from './AppPage';
import content from './content/macos.json';

const MacOSAppPage = () => (
  <AppPage content={content}>
    <section className="features-section" style={{ backgroundColor: 'var(--bg-secondary)', marginTop: '2rem', borderRadius: '24px' }}>
      <h2 className="section-title gradient-text text-center" style={{ marginBottom: '3rem' }}>Why You Need mChatAI+</h2>
      <div className="features-grid">
        <div className="glass-card feature-card" style={{ padding: '2rem' }}>
          <div className="feature-info" style={{ padding: 0 }}>
            <h3 style={{ marginBottom: '1rem', color: 'var(--accent-blue)' }}>Unleashing Full Power</h3>
            <p style={{ lineHeight: '1.6' }}>Leverage the full computational power of your Mac. mChatAI+ seamlessly integrates with your local environment to execute complex workflows, run local LLMs, and handle intensive automation tasks without relying entirely on the cloud.</p>
          </div>
        </div>
        <div className="glass-card feature-card" style={{ padding: '2rem' }}>
          <div className="feature-info" style={{ padding: 0 }}>
            <h3 style={{ marginBottom: '1rem', color: 'var(--accent-purple)' }}>Seamless Sync</h3>
            <p style={{ lineHeight: '1.6' }}>Your data flows effortlessly between iOS and macOS. With CloudKit integration, your active chats, AI To-Do lists, and agent sessions are instantly available across all your Apple devices.</p>
          </div>
        </div>
        <div className="glass-card feature-card" style={{ padding: '2rem' }}>
          <div className="feature-info" style={{ padding: 0 }}>
            <h3 style={{ marginBottom: '1rem', color: 'var(--accent-green)' }}>Privacy & Security</h3>
            <p style={{ lineHeight: '1.6' }}>Built with privacy first. All API keys are stored securely in your local macOS Keychain. Local execution means your sensitive data stays on your device unless you explicitly grant network access.</p>
          </div>
        </div>
      </div>
    </section>
  </AppPage>
);

export default MacOSAppPage;
